import type {
  AdvisorClient,
  AdvisorClientKpis,
  AdvisorClientScheduleBucket,
  AdvisorKpiKey,
} from './models';

const isBucket = (value: unknown): value is AdvisorClientScheduleBucket =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as AdvisorClientScheduleBucket).count === 'number' &&
  typeof (value as AdvisorClientScheduleBucket).total === 'number';

const hasBuckets = (value: object, keys: readonly string[]): boolean =>
  keys.every((key) => isBucket((value as Record<string, unknown>)[key]));

const DOCUMENTS_BUCKETS = ['receivable', 'payable'] as const;
const UPCOMING_BUCKETS = ['receivable', 'payable', 'payableToPay'] as const;

/**
 * Durante un rilascio la webapp nuova può leggere la risposta dell'API
 * precedente, senza la divisione per direzione delle rate: quei KPI
 * diventano «non disponibili» invece di far cadere la pagina su un campo
 * mancante. Unico punto di controllo, all'ingresso della risposta.
 */
export function normalizeAdvisorClient(client: AdvisorClient): AdvisorClient {
  const { documents, upcomingSchedules } = client.kpis;
  const incomplete: AdvisorKpiKey[] = [];
  const kpis: AdvisorClientKpis = { ...client.kpis };
  if (documents && !hasBuckets(documents, DOCUMENTS_BUCKETS)) {
    delete kpis.documents;
    incomplete.push('documents');
  }
  if (upcomingSchedules && !hasBuckets(upcomingSchedules, UPCOMING_BUCKETS)) {
    delete kpis.upcomingSchedules;
    incomplete.push('upcomingSchedules');
  }
  if (incomplete.length === 0) return client;
  kpis.unavailable = [...(kpis.unavailable ?? []), ...incomplete];
  return { ...client, kpis };
}
